<mat-form-field2 class="mat-block" [showLabel]="false">
  <input
    matInput
    [type]="bindLabel === 'email' ? 'email' : 'text'"
    [formControl]="ctrl"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    required
  />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSignerSelect($event)">
    <mat-option *ngFor="let model of options$ | async" [value]="model">
      <div
        class="text-truncate d-flex align-items-center"
        [matTooltip]="(model.type === signerTypes.Staff ? 'User' : 'Guest') + ': ' + model.name + '-' + model.email"
        matTooltipPosition="right"
      >
        <i class="far fa-user text-warning" *ngIf="model.type === signerTypes.Staff"></i>
        <i class="far fa-address-book text-primary" *ngIf="model.type === signerTypes.Guest"></i>
        &nbsp;
        {{ model.name }}
        &nbsp;
        <span class="text-light"> - {{ model.email }} </span>
      </div>
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
    {{ label || placeholder }} <ng-container i18n>is required</ng-container>
  </mat-error>
  <mat-error *ngIf="ctrl.hasError('duplicated')" i18n>This signing role is already in use.</mat-error>
</mat-form-field2>
